import React from 'react';
import { arrayOf, shape, string, instanceOf } from 'prop-types';
import { timeToShortString } from '../../../utils/dates';

export default function TimeSummary({ entries }) {
    if (entries.length === 0) {
        return null;
    }

    return (
        <div className="time-summary-section">
            {entries.map((entry, index) => (
                <div
                    className={`time-summary-entry ${entry.modifier}`}
                    /* eslint-disable-next-line react/no-array-index-key */
                    key={index}
                >
                    <div className="time-summary-label">
                        {entry.label}
                    </div>
                    <div className="time-summary-value">
                        {timeToShortString(entry.value)}
                    </div>
                </div>
            ))}
        </div>
    );
}

TimeSummary.propTypes = {
    entries: arrayOf(shape({
        label: string.isRequired,
        value: instanceOf(Date).isRequired,
        className: string
    }))
};

TimeSummary.defaultProps = { entries: [] };
